import type { CSSProperties } from "react";

// Мелочи оформления списков версий в панели и на странице истории.

export const sectionTitleStyle: CSSProperties = {
  fontSize: "0.65625rem",
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--fg-2)",
};
